// @ts-nocheck
import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

import styles from './TextCell.module.scss'

export const TextCell = ({
  className,
  justify = 'center',
  text,
  maxWidth,
  hasIncreasedHeight,
}) => (
  <Table.Cell type="body" {...{ className, maxWidth, hasIncreasedHeight }}>
    <Box
      align="center"
      className={styles.content}
      tagName="span"
      {...{ justify }}
    >
      {text}
    </Box>
  </Table.Cell>
)
